import { withStyles } from "@material-ui/core";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Clear from "@material-ui/icons/CancelOutlined";
import { SortRounded } from "@material-ui/icons";
import Select from "react-select";

const styles = (theme) => ({
  reactSelect: {
    "&$themedReactSelect .select__control": {
      backgroundColor: theme.gridBGColor,
      borderRadius: 0,
      border: `1px solid ${theme.iconColor}`,
      height:"32px",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`,
      },
    },
    "& .select__control": {
      backgroundColor: theme.driverReportFilterBGColor,
      fontSize: 12,
      cursor: "pointer",
      minWidth: 175,
      borderRadius: "15px",
      minHeight: 30,
      margin: 8,
      border: "none",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: "none",
      },
      "& .select__value-container": {
        color: theme.TextColor,
        padding: "0px 12px",
        "& .select__input": {
          color: theme.TextColor,
        },
        "&>div": {
          margin: 0,
        },
        "&>.select__multi-value": {
          margin: 2,
          backgroundColor: theme.HeaderSelectedText,
          "&>div": {
            color: "white",
            padding: 4,
          },
          "& .select__multi-value__remove": {
            padding: "4px 0",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: theme.HeaderSelectedText,
            },
          },
        },
      },
      "& .select__single-value": {
        color: "inherit",
      },
      "& .select__indicators": {
        padding: 8,
        "& .select__indicator": {
          padding: 8,
        },
        "& .select__indicator-separator": {
          margin: 0,
          display: "none",
        },
      },
    },
    "& .select__menu": {
      margin: 0,
      maxHeight: 140,
      borderRadius: 2,
      zIndex: 24,
      border: `1px solid ${theme.iconColor}`,
      "& .select__menu-list": {
        maxHeight: 138,
        borderRadius: 2,
        fontSize: 12,
        paddingBottom: 0,
        paddingTop: 0,
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor,
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer",
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HeaderSelectedText,
      },
    },
  },

  themedReactSelect: {},

  iconStyle: {
    color: theme.iconColor,
    cursor: "pointer",
  },

  multiValueApplied: {
    "& .select__control": {
      background: theme.HighlightColor,
    },
  },
});

const CustomSelect = ({
  name,
  value,
  onChange,
  options,
  classes,
  themed= false,
  ...otherProps
}) => {
  const selectClasses = [
                        classes.reactSelect , 
                        themed ? classes.themedReactSelect : null ,  
                        Array.isArray(value) && value.length > 0 ? classes.multiValueApplied: ""
                      ].filter(Boolean).join(" ")
  return (
    <Select
      name={name}
      classNamePrefix={"select"}
      className={selectClasses}
      value={value}
      onChange={onChange}
      options={options}
      components={{
        DropdownIndicator: (props) => (
          <ArrowDropDown {...props.innerProps} className={classes.iconStyle} />
        ),
        ClearIndicator: (props) => {
          return (
            <div>
              {props.selectProps.isSortControl && <SortRounded />}
              <Clear {...props.innerProps} className={classes.iconStyle} />
            </div>
          );
        },
      }}
      {...otherProps}
    />
  );
};

export default withStyles(styles)(CustomSelect);
